import { render } from "./LicenseApp.vue?vue&type=template&id=420547a7"
import script from "./LicenseApp.vue?vue&type=script&lang=js"
export * from "./LicenseApp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__